import { Menu } from 'lucide-react';
import { EnvironmentChips } from './EnvironmentChips';
import { SearchField } from '../../ui/SearchField';
import { NotificationBellMenu } from './NotificationBellMenu';
import { UserAvatarButton } from './UserAvatarButton';
import { } from '../../../api/endpoints/plant';

export interface TopbarProps {
  title: string;
  onMenuClick: () => void;
}

export function Topbar({ title, onMenuClick }: TopbarProps) {
  return (
    <header className="sticky top-0 z-30 flex items-center gap-3.5 border-b border-border bg-surface px-4 py-3 md:px-6">
      <button
        type="button"
        onClick={onMenuClick}
        aria-label="open navigation"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-text-secondary hover:bg-surface-hover md:hidden"
      >
        <Menu size={20} />
      </button>

      <div className="min-w-0">
        <p className="truncate text-base font-bold text-text-primary">{title}</p>
        <div className="flex items-center gap-1.5">
          <span className="h-1.5 w-1.5 rounded-full bg-success" />
          <p className="truncate text-xs text-text-secondary">S.P.A. International Food · Fish Oil</p>
        </div>
      </div>

      <div className="flex-1" />

      <EnvironmentChips />

      <SearchField placeholder="Search tags, alarms, batches…" className="hidden w-[230px] sm:flex" />

      <NotificationBellMenu />
      <UserAvatarButton />
    </header>
  );
}
